import React, { useState } from "react";
import { setLaunch } from "./config";

// A tiny, unobtrusive dot (bottom-left) opens a passphrase-protected launch switch.
// This lets you flip the site between pre-launch (waitlist) and live (store badges) in-app.
export default function AdminPanel({ isPostLaunch, onChange }) {
  const [open, setOpen] = useState(false);
  const [token, setToken] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const apply = async (value) => {
    setBusy(true);
    setError("");
    const res = await setLaunch(value, token.trim());
    setBusy(false);
    if (res.ok) {
      onChange(res.is_post_launch);
    } else {
      setError(res.error || "Error.");
    }
  };

  return (
    <>
      <button
        className="bb-admin-dot"
        aria-label="Admin"
        title="Admin"
        data-testid="admin-dot"
        onClick={() => setOpen(true)}
      />
      {open && (
        <div className="bb-admin-backdrop" onClick={() => setOpen(false)}>
          <div className="bb-admin-panel" onClick={(e) => e.stopPropagation()}>
            <p className="ff-mono text-[10px] uppercase tracking-[0.2em]" style={{ color: "var(--bb-red)" }}>
              Launch switch
            </p>
            <h3 className="ff-head text-2xl mt-2" style={{ color: "var(--bb-ink)" }}>
              {isPostLaunch ? "Live \u2014 store badges" : "Pre-launch \u2014 waitlist"}
            </h3>
            <p className="ff-sans text-sm mt-2" style={{ color: "var(--bb-ink-muted)" }}>
              Enter the admin passphrase, then choose what visitors see.
            </p>

            <input
              data-testid="admin-passphrase"
              type="password"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              placeholder="Passphrase"
              className="mt-4 w-full h-11 rounded-[12px] border px-4 ff-sans text-[15px]"
              style={{ background: "var(--bb-surface)", borderColor: "var(--bb-border-strong)", color: "var(--bb-ink)" }}
            />

            <div className="mt-4 flex gap-3">
              <button
                data-testid="admin-set-prelaunch"
                disabled={busy}
                onClick={() => apply(false)}
                className="flex-1 h-11 rounded-[12px] ff-sans text-sm font-medium border"
                style={{
                  background: !isPostLaunch ? "var(--bb-red)" : "transparent",
                  color: !isPostLaunch ? "#0A0A0A" : "var(--bb-ink)",
                  borderColor: "var(--bb-border-strong)",
                }}
              >
                Pre-launch
              </button>
              <button
                data-testid="admin-set-live"
                disabled={busy}
                onClick={() => apply(true)}
                className="flex-1 h-11 rounded-[12px] ff-sans text-sm font-medium border"
                style={{
                  background: isPostLaunch ? "var(--bb-red)" : "transparent",
                  color: isPostLaunch ? "#0A0A0A" : "var(--bb-ink)",
                  borderColor: "var(--bb-border-strong)",
                }}
              >
                Go live
              </button>
            </div>

            {error && (
              <p data-testid="admin-error" className="ff-sans text-sm mt-3" style={{ color: "var(--bb-red)" }}>
                {error}
              </p>
            )}

            <button
              onClick={() => setOpen(false)}
              className="mt-5 ff-mono text-[11px] uppercase tracking-[0.18em]"
              style={{ color: "var(--bb-ink-faint)", background: "transparent", border: "none", cursor: "pointer" }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}
